import { render } from "./JailRoster.vue?vue&type=template&id=25251c86"
import script from "./JailRoster.vue?vue&type=script&lang=js"
export * from "./JailRoster.vue?vue&type=script&lang=js"

import "./JailRoster.vue?vue&type=style&index=0&id=25251c86&lang=css"

import exportComponent from "D:\\a\\1\\s\\VueApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__